/* eslint-disable react/no-unescaped-entities */
import React, { Component } from "react";
import {
  Shield,
  UserPlus,
  CheckCircle,
  AlertCircle,
  QrCode,
  Gift,
  ShoppingCart,
  ArrowLeft,
} from "lucide-react";
import { Navigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import trLabels from "react-phone-number-input/locale/tr.json";
// Kayıt akışı sadeleştirildi ve kendi bileşenine taşındı; bu sayfa artık
// sekme seçimi, üyelik ücreti ve hediye kodu SATIN ALMA akışını yönetiyor.
import KayitYeni from "./KayitYeni";

export default class RegisterPosnet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "register",
      giftCodeQuantity: 1,
      birimUcretTl: null, // sunucudan okunur; gelene kadar tutar gösterilmez ve satın alma kapalı
      isLoading: false,
      message: { type: "", text: "" },
      shouldRedirect: null,
      giftCodePhone: "",
      redirectTimer: null,
      giftCodeAcceptTerms: false,
    };
  }

  API_BASE_URL = process.env.REACT_APP_API_URL;

  componentDidMount() {
    this.uyelikUcretiGetir();
  }

  // Üyelik ücreti panelden değişebildiği için sunucudan okunur
  uyelikUcretiGetir = async () => {
    try {
      const response = await fetch(`${this.API_BASE_URL}/api/posnet/uyelik-ucreti`);
      const result = await response.json();
      if (result.success && result.tl) {
        this.setState({ birimUcretTl: result.tl });
        return;
      }
    } catch (error) {
      console.error("Üyelik ücreti alınamadı:", error);
    }
    // Sabit bir tutar gösterip farklı tutarla ödeme açmamak için ücret yoksa satın alma kapalı kalır
    this.setState({ message: { type: "error", text: "Üyelik ücreti alınamadı. Sayfayı yenileyip tekrar deneyin." } });
  };

  // Ücret henüz gelmediyse tutar yerine "…"
  tutarMetni = (tl) => (this.state.birimUcretTl === null ? "…" : Number(tl).toLocaleString("tr-TR"));

  componentWillUnmount() {
    if (this.state.redirectTimer) {
      clearTimeout(this.state.redirectTimer);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.message.text !== this.state.message.text &&
      this.state.message.text
    ) {
      if (this.state.message.type === "error") {
        setTimeout(() => {
          if (this.state.message.type === "error") {
            this.setState({ message: { type: "", text: "" } });
          }
        }, 5000);
      }
    }
  }

  handleApiError = (
    error,
    defaultMessage = "Bir hata oluştu. Lütfen tekrar deneyin.",
  ) => {
    console.error("API Error:", error);
    let errorMessage = defaultMessage;

    if (error.message === "Failed to fetch") {
      errorMessage = "Bağlantı hatası. İnternet bağlantınızı kontrol edin.";
    } else if (error.name === "TypeError") {
      errorMessage =
        "Sunucuya bağlanılamadı. Lütfen daha sonra tekrar deneyin.";
    }

    this.setState({
      message: { type: "error", text: errorMessage },
      isLoading: false,
    });
  };

  handleGiftCodePurchase = async () => {
    try {
      const { giftCodeQuantity, giftCodePhone, giftCodeAcceptTerms } =
        this.state;

      if (!giftCodeAcceptTerms) {
        this.setState({
          message: {
            type: "error",
            text: "Hediye kodu satın almak için üyelik & satış sözleşmesini kabul etmelisiniz.",
          },
          isLoading: false,
        });
        return;
      }

      const response = await fetch(
        `${this.API_BASE_URL}/api/posnet/hediye-kodu-satin-al`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            orderCount: giftCodeQuantity,
            phone: giftCodePhone || null,
            acceptTerms: giftCodeAcceptTerms,
            // Sayfada gösterilen birim ücret: sayfa açıkken ücret değiştiyse sunucu oturum açmaz, yeni ücret gösterilir
            gosterilenUcretKurus: Math.round(this.state.birimUcretTl * 100),
          }),
        },
      );

      const result = await response.json();

      if (result.kod === "ucret_degisti") {
        this.setState({
          birimUcretTl: result.tl,
          message: { type: "error", text: result.message },
          isLoading: false,
        });
        return;
      }

      if (result.success && result.orderId) {
        this.setState({
          shouldRedirect: `/posnet-payment-gift/${result.orderId}?amount=${result.amount}&quantity=${result.quantity}`,
          isLoading: false,
        });
      } else {
        this.setState({
          message: {
            type: "error",
            text: result.message || "Hediye kodu satın alma işlemi başarısız.",
          },
          isLoading: false,
        });
      }
    } catch (error) {
      this.handleApiError(
        error,
        "Hediye kodu satın alma işleminde hata oluştu.",
      );
    }
  };

  handleRegister = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true, message: { type: "", text: "" } });

    if (this.state.selectedOption === "giftCode") {
      await this.handleGiftCodePurchase();
      return;
    }

    // Kayıt akışı KayitYeni bileşenine taşındı; bu form yalnızca hediye kodu
    // SATIN ALMA sekmesinin gönderimini yürütüyor.
  };

  handleOptionChange = (option) => {
    if (this.state.redirectTimer) {
      clearTimeout(this.state.redirectTimer);
      this.setState({ redirectTimer: null });
    }

    this.setState({
      selectedOption: option,
      message: { type: "", text: "" },
      isLoading: false,
      giftCodeAcceptTerms: false,
    });
  };

  handleQuantityChange = (quantity) => {
    this.setState({ giftCodeQuantity: Math.max(1, Math.min(100, quantity)) });
  };

  handleLoginNavigation = () => {
    if (this.state.redirectTimer) {
      clearTimeout(this.state.redirectTimer);
      this.setState({ redirectTimer: null });
    }

    this.setState({ shouldRedirect: "/login" });
  };

  renderOptionSelector = () => {
    const { selectedOption } = this.state;

    return (
      <div style={{ marginBottom: "30px" }}>
        <div
          style={{
            display: "flex",
            gap: "15px",
            padding: "8px",
            background: "#f8fafc",
            borderRadius: "16px",
            border: "2px solid #e2e8f0",
          }}
        >
          <button
            type="button"
            onClick={() => this.handleOptionChange("register")}
            style={{
              flex: 1,
              padding: "20px 15px",
              border: "none",
              borderRadius: "12px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              transition: "all 0.3s ease",
              background:
                selectedOption === "register"
                  ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                  : "transparent",
              color: selectedOption === "register" ? "white" : "#64748b",
              boxShadow:
                selectedOption === "register"
                  ? "0 4px 15px rgba(16, 185, 129, 0.3)"
                  : "none",
            }}
          >
            <UserPlus size={24} />
            <span>Kayıt Ol</span>
          </button>

          <button
            type="button"
            onClick={() => this.handleOptionChange("giftCode")}
            style={{
              flex: 1,
              padding: "20px 15px",
              border: "none",
              borderRadius: "12px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              transition: "all 0.3s ease",
              background:
                selectedOption === "giftCode"
                  ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                  : "transparent",
              color: selectedOption === "giftCode" ? "white" : "#64748b",
              boxShadow:
                selectedOption === "giftCode"
                  ? "0 4px 15px rgba(245, 158, 11, 0.3)"
                  : "none",
            }}
          >
            <Gift size={24} />
            <span>Hediye Kodu</span>
          </button>
        </div>
      </div>
    );
  };

  renderGiftCodeQuantity = () => {
    const { giftCodeQuantity } = this.state;

    return (
      <div style={{ marginBottom: "25px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "12px",
            fontSize: "16px",
            fontWeight: "600",
            color: "#374151",
            textAlign: "center",
          }}
        >
          Kaç adet hediye kodu satın almak istiyorsunuz?
        </label>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "15px",
            padding: "20px",
            background: "#fef3c7",
            borderRadius: "16px",
            border: "2px solid #fbbf24",
            marginBottom: "20px",
          }}
        >
          <button
            type="button"
            onClick={() => this.handleQuantityChange(giftCodeQuantity - 1)}
            disabled={giftCodeQuantity <= 1}
            style={{
              width: "45px",
              height: "45px",
              border: "2px solid #d97706",
              borderRadius: "12px",
              background: giftCodeQuantity <= 1 ? "#fbbf24" : "white",
              color: giftCodeQuantity <= 1 ? "white" : "#d97706",
              fontSize: "20px",
              fontWeight: "bold",
              cursor: giftCodeQuantity <= 1 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            -
          </button>

          <div
            style={{
              padding: "12px 25px",
              background: "white",
              borderRadius: "12px",
              border: "2px solid #d97706",
              fontSize: "18px",
              fontWeight: "700",
              color: "#92400e",
              minWidth: "80px",
              textAlign: "center",
            }}
          >
            {giftCodeQuantity}
          </div>

          <button
            type="button"
            onClick={() => this.handleQuantityChange(giftCodeQuantity + 1)}
            disabled={giftCodeQuantity >= 100}
            style={{
              width: "45px",
              height: "45px",
              border: "2px solid #d97706",
              borderRadius: "12px",
              background: giftCodeQuantity >= 100 ? "#fbbf24" : "white",
              color: giftCodeQuantity >= 100 ? "white" : "#d97706",
              fontSize: "20px",
              fontWeight: "bold",
              cursor: giftCodeQuantity >= 100 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            +
          </button>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#374151",
            }}
          >
            Telefon Numarası (İsteğe Bağlı)
          </label>
          <PhoneInput
            placeholder="Telefon numaranızı girin"
            value={this.state.giftCodePhone}
            onChange={(value) => this.setState({ giftCodePhone: value })}
            defaultCountry="TR"
            international={true}
            countryCallingCodeEditable={false}
            addInternationalOption={false}
            countries={["TR"]}
            labels={trLabels}
            className="custom-phone-input"

          />
          <div
            style={{
              marginTop: "8px",
              padding: "8px 12px",
              background: "#fef3c7",
              border: "1px solid #f59e0b",
              borderRadius: "8px",
              fontSize: "12px",
              color: "#92400e",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Shield size={12} />
            <span>
              <strong>SMS sadece Türk numaralarına gönderilir.</strong> Telefon
              numarası isteğe bağlıdır.
            </span>
          </div>
        </div>

        <div
          style={{
            padding: "15px",
            background: "#fef3c7",
            borderRadius: "12px",
            textAlign: "center",
            fontSize: "14px",
            color: "#92400e",
            marginBottom: "20px",
          }}
        >
          <strong>Toplam Tutar: {this.tutarMetni(giftCodeQuantity * this.state.birimUcretTl)}₺</strong>
          <br />
          <span style={{ fontSize: "12px", opacity: "0.8" }}>
            Her hediye kodu {this.tutarMetni(this.state.birimUcretTl)}₺
          </span>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
              fontSize: "14px",
              color: "#374151",
              padding: "15px",
              background: "#fef3c7",
              borderRadius: "12px",
              border: "2px solid #f59e0b",
              transition: "all 0.2s ease",
            }}
          >
            <input
              type="checkbox"
              checked={this.state.giftCodeAcceptTerms}
              onChange={(e) =>
                this.setState({ giftCodeAcceptTerms: e.target.checked })
              }
              required
              style={{
                width: "18px",
                height: "18px",
                accentColor: "#f59e0b",
                cursor: "pointer",
              }}
            />
            <span>
              <a
                href="/gizlilik_politikasi/uyelik_satis_sozlesmesi"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#d97706",
                  textDecoration: "none",
                  fontWeight: "600",
                }}
              >
                Üyelik & Satış Sözleşmesi
              </a>
              'ni okudum ve kabul ediyorum *
            </span>
          </label>
        </div>
      </div>
    );
  };

  renderMessage = () => {
    const { message } = this.state;
    if (!message.text) return null;

    return (
      <div
        style={{
          background:
            message.type === "success"
              ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
              : "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
          border: `1px solid ${message.type === "success" ? "#10b981" : "#ef4444"
            }`,
          borderRadius: "12px",
          padding: "15px 20px",
          marginBottom: "25px",
          color: message.type === "success" ? "#065f46" : "#991b1b",
          fontSize: "14px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {message.type === "success" ? (
          <CheckCircle size={16} />
        ) : (
          <AlertCircle size={16} />
        )}
        {message.text}
      </div>
    );
  };

  render() {
    const { isLoading, shouldRedirect, selectedOption } = this.state;

    if (shouldRedirect) {
      return <Navigate to={shouldRedirect} />;
    }

    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }

            @keyframes float {
              0%, 100% { transform: translateY(0px) rotate(0deg); }
              25% { transform: translateY(-20px) rotate(5deg); }
              50% { transform: translateY(-10px) rotate(-5deg); }
              75% { transform: translateY(-25px) rotate(3deg); }
            }

            .custom-phone-input {
              border: 2px solid #e2e8f0;
              border-radius: 12px;
              padding: 8px 15px;
              background: #ffffff;
              transition: border-color 0.2s ease;
            }

            .custom-phone-input:focus-within {
              border-color: #10b981;
              box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
            }

            .PhoneInputInput {
              border: none !important;
              outline: none !important;
              font-size: 15px;
              padding: 8px 0;
            }

            .PhoneInputCountrySelect {
              border: none;
              background: none;
              padding: 8px;
            }

            ::-webkit-scrollbar {
              width: 8px;
            }

            ::-webkit-scrollbar-track {
              background: #f1f5f9;
              border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb {
              background: #cbd5e1;
              border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:hover {
              background: #94a3b8;
            }

            button:hover:not(:disabled) {
              transform: translateY(-1px);
            }

            input:focus, select:focus {
              outline: none !important;
            }

            @media (max-width: 768px) {
              .animated-bg {
                display: none !important;
              }
            }
          `}
        </style>

        {/* Animasyonlu arka plan elemanları */}
        <div
          className="animated-bg"
          style={{
            position: "absolute",
            top: "10%",
            left: "10%",
            width: "100px",
            height: "100px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "50%",
            opacity: "0.1",
            animation: "float 6s ease-in-out infinite",
            zIndex: 0,
          }}
        />
        <div
          className="animated-bg"
          style={{
            position: "absolute",
            bottom: "15%",
            right: "15%",
            width: "150px",
            height: "150px",
            background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            borderRadius: "50%",
            opacity: "0.1",
            animation: "float 8s ease-in-out infinite reverse",
            zIndex: 0,
          }}
        />

        <div
          className="main-container register-main-container"
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
            borderRadius: "24px",
            padding: "50px",
            boxShadow: "0 25px 80px rgba(0,0,0,0.15)",
            width: "100%",
            maxWidth: "700px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {/* Geri Dön Butonu */}
          <button
            onClick={() => this.setState({ shouldRedirect: "/" })}
            style={{
              position: "absolute",
              top: "20px",
              left: "20px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              background: "transparent",
              color: "#64748b",
              border: "none",
              fontWeight: "600",
              fontSize: "13px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              zIndex: 10,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1e293b";
              e.currentTarget.style.transform = "translateX(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#64748b";
              e.currentTarget.style.transform = "translateX(0)";
            }}
          >
            <ArrowLeft size={14} />
            Geri Dön
          </button>

          {/* Güvenli işlem badge */}
          <div
            className="register-guvenli-rozet"
            style={{
              position: "absolute",
              top: "-15px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#ffffff",
              padding: "8px 20px",
              borderRadius: "20px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#64748b",
            }}
          >
            <Shield size={14} style={{ color: "#10b981" }} />
            Güvenli İşlem
          </div>

          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <div
              style={{
                background:
                  selectedOption === "register"
                    ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                    : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 25px",
                color: "white",
                boxShadow:
                  selectedOption === "register"
                    ? "0 8px 25px rgba(16, 185, 129, 0.25)"
                    : "0 8px 25px rgba(245, 158, 11, 0.25)",
                transition: "all 0.3s ease",
              }}
            >
              {selectedOption === "register" ? (
                <UserPlus size={35} />
              ) : (
                <Gift size={35} />
              )}
            </div>

            <h2
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginBottom: "10px",
                color: "#1e293b",
              }}
            >
              {selectedOption === "register"
                ? "Hesap Oluşturun"
                : "Hediye Kodu Satın Alın"}
            </h2>
            <p
              style={{
                color: "#64748b",
                fontSize: "16px",
                lineHeight: "1.6",
                margin: "0",
              }}
            >
              {selectedOption === "register"
                ? "Güvenli ödeme - Bilgilerinizi girerek hemen hesabınızı oluşturun"
                : "Sevdikleriniz için hediye kodu satın alın"}
            </p>
          </div>

          {this.renderOptionSelector()}

          {selectedOption === "giftCode" ? (
            <form onSubmit={this.handleRegister}>
              {this.renderGiftCodeQuantity()}
              {this.renderMessage()}

              <button
                type="submit"
                disabled={isLoading || !this.state.giftCodeAcceptTerms || this.state.birimUcretTl === null}
                style={{
                  background:
                    isLoading || !this.state.giftCodeAcceptTerms
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                  color: "white",
                  padding: "18px 40px",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor:
                    isLoading || !this.state.giftCodeAcceptTerms
                      ? "not-allowed"
                      : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "center",
                  width: "100%",
                  boxShadow:
                    isLoading || !this.state.giftCodeAcceptTerms
                      ? "none"
                      : "0 8px 25px rgba(245, 158, 11, 0.3)",
                  marginBottom: "25px",
                  transition: "all 0.2s ease",
                  opacity:
                    isLoading || !this.state.giftCodeAcceptTerms ? "0.6" : "1",
                }}
              >
                {isLoading ? (
                  <>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid #ffffff",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    İşleminiz hazırlanıyor...
                  </>
                ) : (
                  <>
                    <ShoppingCart size={18} />
                    Hediye Kodu Satın Al ({this.tutarMetni(this.state.giftCodeQuantity * this.state.birimUcretTl)}₺)
                  </>
                )}
              </button>
            </form>
          ) : (
            // Sadelestirilmis kayit akisi ayri bilesende: 3 adim, kayitta
            // yalnizca ad/soyad/telefon. Eski 13 alanli tek sayfa form
            // kaldirildi; kalan alanlar uygulama icinde profil tamamlamada
            // toplaniyor. Hediye kodu SATIN ALMA sekmesi degismedi.
            <KayitYeni birimUcretTl={this.state.birimUcretTl} />
          )}

          <div
            style={{
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              textAlign: "center",
            }}
          >
            <p
              style={{
                color: "#64748b",
                fontSize: "15px",
                margin: "0 0 15px 0",
              }}
            >
              Zaten hesabınız var mı?
            </p>
            <button
              type="button"
              onClick={this.handleLoginNavigation}
              style={{
                background: "none",
                border: "1px solid #e2e8f0",
                color: "#64748b",
                padding: "12px 25px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
              }}
            >
              <QrCode size={16} />
              Giriş Yap
            </button>
          </div>
        </div>
      </div>
    );
  }
}
